<template>
  <div>
    <transition name="assistant">
      <div class="assistant">
        <a-popover placement="leftTop" v-model="visible">
          <template slot="content">
            <strong>{{ "云账号配置向导" }}</strong>
            <div v-if="!user_guide.first_time_setup">
              <p>{{ "已完成云账号初始配置, 是否关闭此图标?" }}</p>
              <span>{{ "您可通过页面右上角导航栏, 点击"}}</span>
              <icon type="navbar-more" style="font-size: 24px;" />
              <span>{{ "打开配置向导。" }}</span>
              <div style="text-align: right">
                <a-button type="primary" shape="round" size="small" @click="close">
                  {{ $t('scope.assistant.confirm')}}
                </a-button>
                <a-button type="link" @click="hide">
                  {{ $t('scope.assistant.ignore')}}
                </a-button>
              </div>
            </div>
          </template>
          <a-button type="primary" shape="circle" @click="openDialog" icon="control" />
        </a-popover>
      </div>
    </transition>
    <welcome-screen v-if="show" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import WelcomeScreen from '@scope/views/common/components/WelcomeScreen'

export default {
  name: 'CloudAccountAssistantShortcut',
  components: {
    WelcomeScreen,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      visible: false,
    }
  },
  computed: {
    ...mapGetters(['scope', 'isAdminMode', 'isDomainMode']),
    ...mapGetters('app', ['showWelcomeScreen']),
    ...mapState('app', {
      user_guide: state => state.user_guide,
    }),
    show () {
      if (this.isAdminMode || this.isDomainMode) {
        return this.showWelcomeScreen
      }
      return false
    },
  },
  methods: {
    close () {
      this.$store.dispatch('app/disableUserGuideAssistantShortcut')
    },
    hide () {
      this.visible = false
    },
    openDialog () {
      this.createDialog('CloudAccountSetupGuideDialog', this.params)
    },
  },
}
</script>

<style lang="less" scoped>
.assistant {
  padding-right: 8px;
  position: fixed;
  right: 0px;
  bottom: 85px;
  z-index: 101;
}

.assistant-enter-active, .assistant-leave-active {
  transition: all .5s ease;
}
.assistant-enter, .assistant-leave-to {
  opacity: 0;
}
</style>
